/** Literal TypeScript port of the Sparks Box app's lib/search.js — same
 *  token-AND ranked search, same field weights, same tie-breaking. */

import type { SparkBoxItem } from "./spark-box-manifest";

const FIELDS: { key: keyof SparkBoxItem; weight: number }[] = [
  { key: "name", weight: 40 },
  { key: "title", weight: 40 },
  { key: "category", weight: 20 },
  { key: "forUseBy", weight: 16 },
  { key: "description", weight: 10 },
];

const WORD_BREAK = /[\s\-/(&"']/;

export const tokenize = (query: string): string[] =>
  String(query || "")
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

const scoreToken = (item: SparkBoxItem, token: string): number => {
  let best = 0;
  for (const { key, weight } of FIELDS) {
    const value = String(item[key] || "").toLowerCase();
    const at = value.indexOf(token);
    if (at === -1) continue;

    let score = weight;
    if (value === token) score += weight * 2;
    else if (at === 0) score += weight;
    else if (WORD_BREAK.test(value[at - 1])) score += weight / 2;

    if (score > best) best = score;
  }
  return best;
};

export const scoreSpark = (item: SparkBoxItem, tokens: string[], phrase: string): number => {
  let total = 0;
  for (const token of tokens) {
    const score = scoreToken(item, token);
    if (score === 0) return 0;
    total += score;
  }

  if (
    tokens.length > 1 &&
    String(item.name || "")
      .toLowerCase()
      .includes(phrase)
  ) {
    total += 60;
  }

  return total;
};

export const searchSparks = (items: SparkBoxItem[], query: string): SparkBoxItem[] => {
  const list = items || [];
  const tokens = tokenize(query);
  if (tokens.length === 0) return list;

  const phrase = tokens.join(" ");

  return list
    .map((item, index) => ({ item, index, score: scoreSpark(item, tokens, phrase) }))
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .map((entry) => entry.item);
};
